<template>
    <div class="wrapper">
       <Debateblog/>
     <FinalFooter />
    </div>
</template>

<script>
import Debateblog from '@/components/debatePage'
import FinalFooter from '../components/FinalFooter'
    export default {
        components:{
           
            Debateblog,
            FinalFooter
        }
    }
</script>

<style  scoped>
</style>